module.exports = __webpack_public_path__ + "static/img/BG@2x.cbcf7a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktbConsociation/BG@2x.png
// module id = WA1c
// module chunks = 69